module.exports = __webpack_public_path__ + "img/page-right.a7d2070d.svg";